<script setup lang="ts">
import { ExclamationCircleIcon, IdentificationIcon } from '@heroicons/vue/solid'
import {
    AccountNavigationStore,
    navigateTo,
    useAccountNavigationState,
} from '../../../utilities/account/useAccountNavigationPersonal'
import { computed, defineProps, ref } from 'vue'
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'
import { i18n } from '../../../localization'
import Alert from '../../base/Alert.vue'
import AccountPanelPersonalVerification from './pages/AccountPanelPersonalVerification.vue'

const personalAccountState = usePersonalAccountDataState()
const navigationState = useAccountNavigationState() as AccountNavigationStore

const titleText = computed(() => {
    if (personalAccountState.isVerified) {
        return i18n.global.t('verification.verification_successful')
    } else {
        return i18n.global.t('verification.kyc_process')
    }
})

const descriptionText = computed(() => {
    if (personalAccountState.isVerified) {
        return i18n.global.t('verification.verification_successful_description')
    } else {
        return i18n.global.t('verification.kyc_process_description')
    }
})

const props = withDefaults(
    defineProps<{
        onButtonClick?: () => void
        quickEdit?: boolean
    }>(),
    {
        onButtonClick: async () => {
            await navigateTo('Verification')
        },
        quickEdit: false,
    }
)

function clickButton() {
    if (props.quickEdit) {
        showQuickEdit.value = !showQuickEdit.value
    } else {
        props.onButtonClick()
    }
}

const showQuickEdit = ref(false)

const buttonText = computed(() => {
    if (props.quickEdit && showQuickEdit.value) {
        return i18n.global.t('dialog.button.cancel')
    }
    return i18n.global.t('verification.kyc_process_action_button')
})
</script>

<template>
    <div :class="{ 'rounded-md border': quickEdit }">
        <Alert
            :class="{ 'border-none shadow-none': quickEdit }"
            :title-text="titleText"
            :description-text="descriptionText"
            :show-button="navigationState.page !== 'Verification' || quickEdit"
            :button-text="buttonText"
            @click-button="clickButton">
            <template #icon>
                <IdentificationIcon class="h-12 w-12 text-gray-300"></IdentificationIcon>
                <ExclamationCircleIcon
                    class="absolute bottom-0 right-[-5px] h-6 w-6 rounded-full bg-white text-red-400"></ExclamationCircleIcon>
            </template>
        </Alert>
        <div v-if="showQuickEdit" class="border-t">
            <AccountPanelPersonalVerification />
        </div>
    </div>
</template>

<style scoped></style>
